import { Message } from "primereact/message";
import React from "react";
import styled from "styled-components";

const NoDataContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 2rem;
`;

/**
 * NoDataMessage component - Displays "No data available" message
 */
export function NoDataMessage() {
  return (
    <NoDataContainer>
      <Message
        severity="info"
        text="No precalculated allowables data available for this case signature"
        style={{ width: "100%" }}
      />
    </NoDataContainer>
  );
}
